import { render, staticRenderFns } from "./WalletHeader.vue?vue&type=template&id=1a63d403&"
import script from "./WalletHeader.vue?vue&type=script&lang=js&"
export * from "./WalletHeader.vue?vue&type=script&lang=js&"
import style0 from "./WalletHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports